<template>
  <div>
    <div
      v-for="row in scaledRows"
      :key="row.label"
      class="bar-row"
      :title="`${row.label} — ${row.count.toLocaleString()} abandonments, ${row.share} of all`"
    >
      <div class="bar-label" :style="{ width: labelWidth }">{{ row.label }}</div>
      <div class="bar-track">
        <div class="bar-fill" :style="{ width: row.width, backgroundColor: row.color }"></div>
      </div>
      <div class="bar-value">
        <span class="font-weight-bold">{{ row.count.toLocaleString() }}</span>
        <span class="bar-share">{{ row.share }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BarList",
  props: {
    // [{ label, count, color }] — already in the order they should be read.
    rows: { type: Array, required: true },
    // Shares are against the whole period, not just the rows shown here.
    total: { type: Number, default: 0 },
    labelWidth: { type: String, default: "38%" },
  },
  computed: {
    scaledRows() {
      // Bars are scaled to the biggest row so the card always uses its width;
      // the percentage next to it keeps the real proportion readable.
      const max = Math.max(...this.rows.map(r => r.count), 1);
      return this.rows.map(row => ({
        ...row,
        width: row.count > 0 ? `${Math.max((row.count / max) * 100, 0.8)}%` : "0%",
        share: this.total > 0 ? `${((row.count / this.total) * 100).toFixed(1)}%` : "0%",
      }));
    },
  },
};
</script>

<style scoped>
.bar-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 4px;
  border-radius: 4px;
}

.bar-row:hover {
  background-color: rgba(11, 11, 11, 0.04);
}

.bar-label {
  flex: 0 0 auto;
  text-align: right;
  font-size: 13px;
  color: #0b0b0b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bar-track {
  flex: 1 1 auto;
  height: 14px;
  min-width: 40px;
  background-color: #f1f0ec;
  border-radius: 3px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  border-radius: 0 3px 3px 0;
  transition: width 0.35s ease;
}

.bar-value {
  flex: 0 0 auto;
  width: 92px;
  font-size: 13px;
  text-align: right;
  white-space: nowrap;
}

.bar-share {
  margin-left: 6px;
  color: #52514e;
}

@media (max-width: 600px) {
  .bar-label {
    width: 34% !important;
    font-size: 12px;
  }

  .bar-value {
    width: 78px;
    font-size: 12px;
  }
}
</style>
